function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 20s.41 17.794 4.018 24.877c-.018 2.122 2.984 4.53 5.216 6.053C20 54 23.944 53.755 28 54.334c3.358-.48 7-.334 8.385-2.602 2.8-1.214 5.866-2.704 5.58-5.287C46.407 39.445 47 20 47 20s-3.692 22.346-10.939 15.277c-3.36-3.276-5.06-3.277-8.06-1.277-3-2-4-2-8.276 1.385C12.105 41.419 9 20 9 20zm17.156 18.746c.525-.019 1.13.052 1.848.254 4.032-1 4.038 1.513 6.5 1.5-.007.043-1.593 2.5-6.5 1.8-4.5.7-6.544-1.67-6.5-1.8 1.625.077 2.377-1.673 4.652-1.754z",
  fillRule: "evenodd",
  fill: "var(--primary-color, #000)"
});

var SvgBeard = function SvgBeard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Beard.f1f6e681.svg";
export { ForwardRef as ReactComponent };